import { render, staticRenderFns } from "./StaffingPage.vue?vue&type=template&id=438bfae2&scoped=true"
import script from "./StaffingPage.vue?vue&type=script&lang=js"
export * from "./StaffingPage.vue?vue&type=script&lang=js"
import style0 from "./StaffingPage.vue?vue&type=style&index=0&id=438bfae2&prod&lang=scss&scoped=true"
import style1 from "./StaffingPage.vue?vue&type=style&index=1&id=438bfae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438bfae2",
  null
  
)

export default component.exports